/** @format */

'use strict';

(function () {
  angular.module('sis-components.number', ['sis-components.number.creditRangeEditor', 'sis-components.number.decimalInput', 'sis-components.number.percentEditor', 'sis-components.number.percentInput', 'sis-components.number.creditRangeFilter', 'sis-components.number.decimalNumberFilter', 'sis-components.number.intRangeFilter', 'sis-components.number.percentFilter']);
})();